module.exports = __webpack_public_path__ + "static/img/uservolume.3a5f28a6.png";